'use strict';

bbw.directive.bbwSmileySelectorTouch = ['bbw.SmileySvc', '$rootScope', '$timeout', function(smileySvc, $rootScope, $timeout) {

    var smileysCollection = smileySvc.getSmileysCollection();

    return {
        scope: {
            'ctrl': '=bbwSmileySelectorTouch',
            'visible': '=bbwSmileySelectorVisible'
        },
        transclude: true,
        templateUrl: bbw.templateUrl('smiley-selector-touch.html'),
        link: function(scope, element) {
            var elContainer = element[0].querySelector('.smileys-container');
            if (!elContainer) {
                throw new Error('.smileys-container element not found');
            }

            var elList = elContainer.querySelector('.smileys-list');
            if (!elList) {
                throw new Error('.smileys-list element not found');
            }

            scope.$watch('visible', function(value, oldValue) {
                if (value && !oldValue) {
                    var cb = function() {
                        swipe(0);
                    };
                    if ($rootScope.$$phase) {
                        scope.$evalAsync(cb);
                    } else {
                        scope.$apply(cb);
                    }
                }
            });

            scope.indicator = {};
            scope.left = 0;

            var swipe = function swipe(direction) {
                if (!elContainer.offsetParent) {
                    return $timeout(function() {
                        swipe(direction);
                    }, 50);
                }
                var visibleWidth = elContainer.offsetParent.offsetWidth;
                var listWidth = elList.offsetWidth;
                var stepsCount = Math.ceil(listWidth / visibleWidth);
                var swipeStep = Math.round(listWidth / stepsCount);
                var minLeft = visibleWidth - listWidth;
                if (direction) {
                    scope.left += (direction * swipeStep);
                    if (scope.left > 0) {
                        scope.left = 0;
                    } else if (scope.left < minLeft) {
                        scope.left = minLeft;
                    }
                } else {
                    scope.left = 0;
                }
                scope.indicator.width = Math.round(swipeStep * Math.min(1, visibleWidth / listWidth));
                scope.indicator.left = Math.round((scope.left / minLeft) * (visibleWidth - scope.indicator.width));
            };

            scope.swipeLeft = function() {
                swipe(-1);
            };

            scope.swipeRight = function() {
                swipe(1);
            };

            scope.select = function(name, $event) {
                $event.preventDefault();
                $event.stopPropagation();
                scope.ctrl.insertSmiley(name, true);
                return false;
            };

            scope.smileys = smileysCollection;
        }
    }

}];
